import React from 'react';

import { FormBase } from '../Interface';
import { EmployeePlannerAbsencePage } from './EmployeePlannerAbsencePage';
import EmployeePlannerAbsenceReports from './EmployeePlannerAbsenceReports';
import { useEmployeePlannerAbsence } from '../../hooks/useEmployeePlannerAbsence';

export const EmployeePlannerMain = () => {
  const employeePlanAbsenceState = useEmployeePlannerAbsence();

  return (
    <FormBase
      name="EmployeePlannerAbsence"
      leftPanelContent={<EmployeePlannerAbsencePage employeePlanAbsenceState={employeePlanAbsenceState} />}
      rightPanelContent={<EmployeePlannerAbsenceReports employeePlanAbsenceState={employeePlanAbsenceState} />}
    ></FormBase>
  );
};
